<template>
    <div class="settings-main-page">
      <v-tabs ref="settingsTab"
              v-model="active"
              color="cyan"
              dark
              slider-color="#5a65db"
              class="settings-tab"
      >
        <v-tab key="categories" ripple>
          {{$t('settings.categories')}}
        </v-tab>
        <v-tab key="home_page" ripple>
          {{$t('settings.home_page')}}
        </v-tab>
        <v-tab key="analytics" ripple>
          {{$t('settings.analytics')}}
        </v-tab>
        <v-tab key="users" ripple>
          <span style="font-size: 11px">{{$t('settings.blocked_users')}}</span>
        </v-tab>
        <v-tab-item>
          <Categories></Categories>
        </v-tab-item>
        <v-tab-item class="home-page-main-sect">
          <v-container>
            <v-card-title class="main-sect-title">
              <h1 class="tabHeader"> {{$t('settings.home_infotext')}}</h1>
            </v-card-title>
            <div v-for="setting in settings" :key="setting.id">
              <v-textarea
                      v-if="['about_us', 'general_description', 'contact_us_description', 'site_info_description'].includes(setting.name)"
                      v-model="setting.value"
                      outline
                      color = 'indigo accent-4'
                      :label="$t('settings.' + setting.name)"
                      rows="4">
              </v-textarea>
              <v-text-field v-else
                            v-model="setting.value"
                            :label="$t('settings.' + setting.name)"
              ></v-text-field>
            </div>
            <v-card-actions  row wrap class="add-cancel-btn-sect">
              <v-btn
                     @click="updateSettings()"
                     color = 'indigo accent-4'
                     :ripple="false" class="add-new-category-btn" flat
              >{{ $t('save') }}</v-btn>
            </v-card-actions>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <analytics></analytics>
        </v-tab-item>
        <v-tab-item>
          <BlockedUsers></BlockedUsers>
        </v-tab-item>
      </v-tabs>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import { EventBus } from '../../event-bus'
import BlockedUsers from './components/BlockedUsers'
import Analytics from './components/Analytics'
import CategoryOrdering from '../modals/CategoryOrdering'
import Categories from './components/Categories'
const getSettings = function (settings, lang) {
  let _settings = []
  if (settings) {
    settings.forEach(setting => {
      setting.SettingTranslations.forEach(st => {
        if (!setting.value) {
          setting.value = st.value
        }
        if (st.languageId === lang.id) {
          setting.value = st.value
        }
      })
      _settings.push(setting)
    })
  }
  return _settings
}

export default {
  name: 'settings',
  components: {
    Analytics,
    CategoryOrdering,
    Categories,
    BlockedUsers

  },
  data: () => ({
    users: [],
    active: null,
    settings: [],
    categoriesTableSearch: '',
    categories: [],
    addCategoryDialog: false,
    editCategoryDialog: false,
    newCategoryData: {},
    editCategoryData: {},
    selectedCategory: null,

    subCategoriesTableSearch: '',
    subCategories: [],
    addSubCategoryDialog: false,
    editSubCategoryDialog: false,
    newSubCategoryData: {},
    editSubCategoryData: {},
    subCategoryParent: null,

    otherCategoriesTableSearch: '',
    otherCategories: [],
    addOtherCategoryDialog: false,
    editOtherCategoryDialog: false,
    newOtherCategoryData: {},
    editOtherCategoryData: {},
    otherCategoryParent: null,
    editOtherCategoryDialogActiveTab: 0,
    otherCategoryMergeItem: null,
    otherSubCategoryMergeItem: null,
    otherSubCategoryMergeItems: []
  }),
  computed: {
    ...mapState({
      activeLanguage: state => state.common.activeLanguage
    }),
    categoriesTableHeaders () {
      return [
        { text: this.$t('settings.name'), align: 'left', sortable: false, value: 'displayInfo.name' },
        { text: this.$t('settings.description'), align: 'left', sortable: false, value: 'displayInfo.description' },
        { text: this.$t('settings.actions'), align: 'left', sortable: false, value: '' }
      ]
    },
    subCategoriesTableHeaders () {
      return [
        { text: this.$t('settings.name'), align: 'left', sortable: false, value: 'displayInfo.name' },
        { text: this.$t('settings.description'), align: 'left', sortable: false, value: 'displayInfo.description' },
        { text: this.$t('settings.actions'), align: 'left', sortable: false, value: '' }
      ]
    },
    otherCategoriesTableHeaders () {
      return [
        { text: this.$t('settings.name'), align: 'left', sortable: false, value: 'displayInfo.name' },
        { text: this.$t('settings.description'), align: 'left', sortable: false, value: 'displayInfo.description' },
        { text: this.$t('settings.actions'), align: 'left', sortable: false, value: '' }
      ]
    }
  },
  methods: {
    languageChanged (lang) {
      this.settings = getSettings(this.settings, lang)
      this.categoriesWithSubCategories()
    },
    getUsers () {
      this.$store.dispatch('friends/getSearchIndividualUsers').then((res) => {
        res.forEach(user => {
          if (user.status === 4) {
            this.users.push({
              id: user.id,
              name: `${user.firstName} ${user.lastName}`,
              avatar: user.image,
              email: user.email,
              date: user.createdAt,
              status: user.status
            })
            console.log(this.users, 'ressssss')
          }
        })
      }).catch(console.error)
    },

    updateSettings () {
      let data = []
      this.settings.forEach(setting => {
        data.push({id: setting.id, value: setting.value, languageId: this.activeLanguage.id})
      })
      if (data.length > 0) {
        this.$store.dispatch('common/updateSettings', {data: data})
          .then((res) => {
            this.settings = getSettings(res.data.settings, this.activeLanguage)
            this.$toastr(res.data.type, res.data.message, this.$t(res.data.type))
          })
          .catch(console.error)
      }
    },
    addCategory () {
      this.$store.dispatch('categories/add', this.newCategoryData)
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
          if (res.type === 'success') {
            this.addCategoryDialog = false
          }
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    openEditCategoryDialog (category) {
      this.editCategoryData = {
        id: category.id,
        name: category.displayInfo.name,
        description: category.displayInfo.description
      }
      this.editCategoryDialog = true
    },
    editCategory () {
      this.$store.dispatch('categories/edit', this.editCategoryData)
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
          if (res.type === 'success') {
            this.editCategoryDialog = false
          }
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    deleteCategory (category) {
      const txt = `${this.$t('settings.confirm_delete_item')} "${category.displayInfo.name}"`
      if (!confirm(txt)) {
        return false
      }

      this.$store.dispatch('categories/delete', {categoryId: category.id})
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    closeAddCategoryDialog () {
      this.addCategoryDialog = false
    },
    closeEditCategoryDialog () {
      this.editCategoryDialog = false
    },
    selectCategory (category) {
      this.selectedCategory = category
      this.subCategoryParent = category
      this.otherCategoryParent = category
      this.subCategories = category.subcategories
    },
    categoriesWithSubCategories () {
      this.$store.dispatch('categories/listWithSubCategoriesForAdmin')
        .then((res) => {
          let _categories = []
          let _subCategories = []
          let _otherCategories = []

          if (res && res.categories && res.categories.length > 0) {
            res.categories.forEach((cat) => {
              if (cat.status === 1) { // 1 = active status
                if (this.selectedCategory && this.selectedCategory.id === cat.id) {
                  if (cat.subcategories && cat.subcategories.length > 0) {
                    cat.subcategories.forEach((subCat) => {
                      if (subCat.status === 1) { // 1 = active status
                        _subCategories.push(subCat)
                      } if (subCat.status === 0) { // 0 = inactive
                        _otherCategories.push(subCat)
                      }
                    })
                  }
                  this.selectedCategory = cat
                  this.subCategoryParent = cat
                }
                _categories.push(cat)
              } else if (cat.status === 0) { // 0 = inactive
                _otherCategories.push(cat)
              }
            })
          }
          this.categories = _categories
          this.subCategories = _subCategories
          this.otherCategories = _otherCategories
        })
        .catch(console.error)
    },
    selectSubCategoryParent (categoryId) {
      const parentCategoryItem = this.categories.filter((cat) => cat.id === categoryId)
      this.subCategoryParent = parentCategoryItem && parentCategoryItem[0]
    },
    addSubCategory () {
      this.newSubCategoryData.parentId = this.subCategoryParent && this.subCategoryParent.id
      this.$store.dispatch('categories/add', this.newSubCategoryData)
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
          if (res.type === 'success') {
            this.addSubCategoryDialog = false
          }
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    openEditSubCategoryDialog (category) {
      this.editSubCategoryData = {
        id: category.id,
        name: category.displayInfo.name,
        description: category.displayInfo.description
      }
      this.selectSubCategoryParent(category.parentId)
      this.editSubCategoryDialog = true
    },
    editSubCategory () {
      this.editSubCategoryData.parentId = (this.subCategoryParent && this.subCategoryParent.id) ? this.subCategoryParent.id : null
      this.$store.dispatch('categories/edit', this.editSubCategoryData)
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
          if (res.type === 'success') {
            this.editSubCategoryDialog = false
          }
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    deleteSubCategory (category) {
      const txt = `${this.$t('settings.confirm_delete_item')} "${category.displayInfo.name}"`
      if (!confirm(txt)) {
        return false
      }

      this.$store.dispatch('categories/delete', {categoryId: category.id})
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    closeAddSubCategoryDialog () {
      this.addSubCategoryDialog = false
    },
    closeEditSubCategoryDialog () {
      this.editSubCategoryDialog = false
    },
    selectOtherCategoryParent (categoryId) {
      const parentCategoryItem = this.categories.filter((cat) => cat.id === categoryId)
      this.otherCategoryParent = parentCategoryItem && parentCategoryItem[0]
    },
    selectOtherCategoryMergeItem (categoryId) {
      const parentCategoryItem = this.categories.filter((cat) => cat.id === categoryId)
      this.otherCategoryMergeItem = parentCategoryItem && parentCategoryItem[0]
      this.otherSubCategoryMergeItem = null
      this.otherSubCategoryMergeItems = this.otherCategoryMergeItem && this.otherCategoryMergeItem.subcategories
    },
    selectOtherSubCategoryMergeItem (categoryId) {
      const parentCategoryItem = this.otherSubCategoryMergeItems.filter((cat) => cat.id === categoryId)
      this.otherSubCategoryMergeItem = parentCategoryItem && parentCategoryItem[0]
    },
    openEditOtherCategoryDialog (category) {
      this.editOtherCategoryData = {
        id: category.id,
        name: category.displayInfo.name,
        description: category.displayInfo.description
      }
      this.editOtherCategoryDialog = true
    },
    editOtherCategory () {
      if (this.editOtherCategoryDialogActiveTab === 0) { // Edit
        this.editOtherCategoryData.parentId = this.otherCategoryParent && this.otherCategoryParent.id
        this.editOtherCategoryData.otherCategory = true
        this.$store.dispatch('categories/edit', this.editOtherCategoryData)
          .then((res) => {
            this.$toastr(res.type, res.message, this.$t(res.type))
            if (res.type === 'success') {
              this.editOtherCategoryDialog = false
            }
          })
          .then(() => {
            this.categoriesWithSubCategories()
          })
          .catch(console.error)
      } else if (this.editOtherCategoryDialogActiveTab === 1) { // Merge
        const mergeData = {
          id: this.editOtherCategoryData.id,
          categoryId: this.otherSubCategoryMergeItem ? this.otherSubCategoryMergeItem.id : (this.otherCategoryMergeItem && this.otherCategoryMergeItem.id)
        }

        this.$store.dispatch('categories/mergeCategory', mergeData)
          .then((res) => {
            this.$toastr(res.type, res.message, this.$t(res.type))
            if (res.type === 'success') {
              this.editOtherCategoryDialog = false
            }
          })
          .then(() => {
            this.categoriesWithSubCategories()
          })
          .catch(console.error)
      } else {
        this.$toastr('error', this.$t('something_wrong'), this.$t('error'))
        this.editOtherCategoryDialog = false
      }
    },
    deleteOtherCategory (category) {
      const txt = `${this.$t('settings.confirm_delete_item')} "${category.displayInfo.name}"`
      if (!confirm(txt)) {
        return false
      }

      this.$store.dispatch('categories/delete', {categoryId: category.id})
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    changeCategoryStatus (category) {
      const txt = `${this.$t('settings.confirm_change_category_status')} "${category.displayInfo.name}"`
      if (!confirm(txt)) {
        return false
      }
      const status = category.status === 0 ? 1 : 0

      this.$store.dispatch('categories/changeStatus', {categoryId: category.id, status: status})
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    changeCategoryVisibility (category) {
      const txt = `${this.$t('settings.confirm_change_category_visibility')} "${category.displayInfo.name}"`
      if (!confirm(txt)) {
        return false
      }
      const active = category.active === 0 ? 1 : 0
      this.$store.dispatch('categories/changeVisibility', {categoryId: category.id, active: active})
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    closeEditOtherCategoryDialog () {
      this.editOtherCategoryDialog = false
    }
  },
  created () {
    this.$store.dispatch('common/getSettings')
      .then((res) => {
        if (res.data && res.data.settings) {
          this.settings = getSettings(res.data.settings, this.activeLanguage)
        }
      })
      .catch(console.error)
    this.categoriesWithSubCategories()
    EventBus.$on('language-changed', this.languageChanged)
  },
  mounted () {
    this.$refs.settingsTab.$el.querySelector('.v-tabs__wrapper').addEventListener('touchstart', function (ev) {
      ev.stopPropagation()
    })
    this.$refs.settingsTab.$el.querySelector('.v-tabs__wrapper').addEventListener('touchend', function (ev) {
      ev.stopPropagation()
    })
  }
}
</script>

<style lang="scss" scoped>
  .toolbar-title {
    @media (max-width: 400px) {
      font-size: 14px;
    }
  }
  @import "../../assets/sass/desktop/mySetting.scss";
</style>



// WEBPACK FOOTER //
// src/components/profilePage/Settings.vue